/* eslint-disable object-shorthand */
/* eslint-disable object-shorthand */
<template>
  <b-row class="mt-2">
    <!-- DATOS PERSONALES -->
    <b-col md="4">
      <titleSection
        title="Datos personales"
        icon="UserIcon"
      />

      <div class="mt-1 mb-2">
        <!-- NOMBRE -->
        <div>
          <p class="m-0">
            <small>Nombre</small>
          </p>
          <h6>{{ data.persona.nombre | capitalize }}
          </h6>
        </div>
        <!-- SEGUNDO NOMBRE -->
        <div v-if="data.persona.segundoNombre">
          <p class="mb-0">
            <small>Segundo nombre</small>
          </p>
          <h6>{{ data.persona.segundoNombre | capitalize }}</h6>
        </div>
        <!-- APELLIDO PATERNO -->
        <div>
          <p class="mb-0">
            <small>Apellido paterno</small>
          </p>
          <h6>
            {{ data.persona.apellidoPaterno | capitalize }}
          </h6>
        </div>
        <!-- APELLIDO MATERNO -->
        <div v-if="data.persona.apellidoMaterno">
          <p class="mb-0">
            <small>Apellido materno</small>
          </p>
          <h6>
            {{ data.persona.apellidoMaterno | capitalize }}
          </h6>
        </div>
        <!-- CORREO -->
        <div>
          <p class="mb-0">
            <small>Correo electrónico personal</small>
          </p>
          <h6>
            {{ data.persona.email }}
          </h6>
        </div>
        <!-- TELÉFONO -->
        <div>
          <p class="mb-0">
            <small>Teléfono personal</small>
          </p>
          <h6>
            {{ data.persona.telefono1 }}
          </h6>
        </div>
        <!-- CORREO LABORAL -->
        <div>
          <p class="mb-0">
            <small>Correo electrónico laboral</small>
          </p>
          <h6>
            {{ data.persona.emailAlt }}
          </h6>
        </div>
        <!-- TELÉFONO LABORAL -->
        <div>
          <p class="mb-0">
            <small>Teléfono laboral</small>
          </p>
          <h6>
            {{ data.persona.telefono2 }}
          </h6>
        </div>
        <!-- EXTENSIÓN -->
        <div>
          <p class="mb-0">
            <small>Extensión</small>
          </p>
          <h6>
            {{ data.persona.extension }}
          </h6>
        </div>
        <!-- CURP -->
        <div>
          <p class="mb-0">
            <small>CURP</small>
          </p>
          <h6>
            {{ data.persona.curp }}
          </h6>
        </div>
        <!-- FECHA NACIMIENTO -->
        <div>
          <p class="mb-0">
            <small>Fecha de nacimiento</small>
          </p>
          <h6>
            {{ data.persona.fechaNacimiento }}
          </h6>
        </div>
      </div>
    </b-col>
    <!-- DATOS DE DIRECCIÓN-->
    <b-col md="4">
      <titleSection
        title="Dirección Personal"
        icon="MapPinIcon"
      />
      <div class="mt-1 mb-2">
        <div>
          <p class="m-0">
            <small class="mb-0">
              Calle
            </small>
          </p>
          <h6>{{ data.direccion.calle | capitalize }}</h6>
        </div>
        <div>
          <p class="m-0">
            <small class="mb-0">
              Número
            </small>
          </p>
          <h6>{{ data.direccion.numero | capitalize }}</h6>
        </div>
        <div>
          <p class="m-0">
            <small class="mb-0">
              Interior
            </small>
          </p>
          <h6>{{ data.direccion.interior | capitalize }}</h6>
        </div>
        <div>
          <p class="m-0">
            <small class="mb-0">
              Código Postal
            </small>
          </p>
          <h6>{{ data.direccion.cp }}</h6>
        </div>
        <div>
          <p class="m-0">
            <small class="mb-0">
              Colonia
            </small>
          </p>
          <h6>{{ data.direccion.colonia | capitalize }}</h6>
        </div>
        <div v-if="isObject(data.direccion.municipio) && !isEmptyObject(data.direccion.municipio)">
          <p class="m-0">
            <small class="mb-0">
              Municipio y Entidad Federativa
            </small>
          </p>
          <h6>{{ data.direccion.municipio.nombre | capitalize }}</h6>
        </div>
      </div>
    </b-col>
    <!-- DATOS ACADÉMICOS -->
    <b-col md="4">
      <titleSection
        title="Datos académicos"
        icon="BookOpenIcon"
      />

      <div class="mt-1 mb-2">
        <!-- GRADO ACADÉMICO -->
        <div>
          <p class="mb-0">
            <small>Último grado de estudios</small>
          </p>
          <h6>{{ (data.academico.nivel_educativo) ? data.academico.nivel_educativo.nombre : '' | capitalize }}
          </h6>
        </div>
        <!-- CARRERA -->
        <div>
          <p class="mb-0">
            <small>Licenciatura de la cual egresó</small>
          </p>
          <h6>
            {{ data.academico.carrera | capitalize }}
          </h6>
        </div>
        <!-- TIPO DE ADMISIÓN -->
        <div>
          <p class="mb-0">
            <small>Tipo de admisión</small>
          </p>
          <h6>
            {{ (data.academico.tipo_admision) ? data.academico.tipo_admision.nombre : '' | capitalize }}
          </h6>
        </div>
        <!-- CÉDULA -->
        <div>
          <p class="mb-0">
            <small>Cédula</small>
          </p>
          <h6>
            {{ data.academico.cedula }}
          </h6>
        </div>
        <!-- INSTITUCIÓN EDUCATIVA -->
        <div>
          <p class="mb-0">
            <small>Institución educativa</small>
          </p>
          <h6>
            {{ data.academico.institucion_educativa }}
          </h6>
        </div>
        <!-- FECHA DE EXPEDICIÓN -->
        <div>
          <p class="mb-0">
            <small>Fecha de expedición de cédula</small>
          </p>
          <h6>
            {{ data.academico.fechaExpedicion }}
          </h6>
        </div>
        <!-- ENTIDAD FEDERATIVA DE TITULACIÓN -->
        <div>
          <p class="mb-0">
            <small>Entidad federativa de titulación</small>
          </p>
          <h6>
            {{ data.academico.efTitulacion && data.academico.efTitulacion.nombre ? data.academico.efTitulacion.nombre : '' }}
          </h6>
        </div>
      </div>
      <titleSection
        title="Datos de ocupación"
        icon="BriefcaseIcon"
      />

      <div class="mt-1 mb-2">
        <!-- DEPENDENCIA -->
        <div v-if="isObject(data.dependencia) && !isEmptyObject(data.dependencia)">
          <p class="mb-0">
            <small>Dependencia</small>
          </p>
          <h6>
            {{ data.dependencia.nombre | capitalize }}
          </h6>
        </div>
        <!-- ENTIDAD FEDERATIVA -->
        <div v-if="isObject(data.entidadFederativa) && !isEmptyObject(data.entidadFederativa)">
          <p class="mb-0">
            <small>Entidad Federativa</small>
          </p>
          <h6>
            {{ data.entidadFederativa.nombre | capitalize }}
          </h6>
        </div>
        <!-- DEPARTAMENTO -->
        <div>
          <p class="mb-0">
            <small>Departamento</small>
          </p>
          <h6>
            <div
              v-if="!data.ocupacion.dptoAlterno"
            >{{ (data.ocupacion.departamento) ? data.ocupacion.departamento.nombre : '' | capitalize }}</div>
            <div
              v-else
            >{{ data.ocupacion.dptoAlterno | capitalize }}</div>
            <!-- <small >{{ (data.ocupacion.departamento) ? data.ocupacion.departamento.nombre : '' }}</small> -->
          </h6>
        </div>
        <!-- PUESTO / CARGO -->
        <div>
          <p class="mb-0">
            Puesto/Cargo
          </p>
          <h6>
            <div
              v-if="!data.ocupacion.puestoalterno"
            >{{ (data.ocupacion.puesto) ? data.ocupacion.puesto.nombre : '' | capitalize }}</div>
            <div
              v-else
            >{{ data.ocupacion.puestoalterno | capitalize }}</div>
          </h6>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import titleSection from '@/views/components/title-section.vue'
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import { isObject, isEmptyObject } from '@core/utils/utils'

export default {
  components: {
    titleSection,
    BRow,
    BCol,
  },
  filters: {
    capitalize(value) {
      if (!value) return ''
      // eslint-disable-next-line no-param-reassign
      value = value.toString()
      return value.toUpperCase()
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isObject,
      isEmptyObject,
    }
  },
}
</script>
